import React from "react";
import { useEffect } from 'react';
import AOS from 'aos';
import '../Pages/Style.css'; // Ensure this CSS file includes your .social-icon styles

const Contact = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,  // animation time in ms
            once: true,      // animate only once when scrolling down
            easing: 'ease-in-out',
            offset: 120,
        });
    }, []);
    return (
        <div className="entry-content" itemProp="text">

            <div
                className="home-background d-flex align-items-start"
                id="contact-background"
                style={{
                    backgroundImage: `url('/Photos/technology-concept-cheerful-man-talking-mobile-phone-having-phone-call-looking-amused-standin.jpg')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'top',
                    height: '450px',
                    color: 'white' // optional: white text for better contrast
                }}
            >
                <div className="w-100 text-end p-4 pt-5 me-4">
                    <h1 className="text-whitee">Contact</h1>
                </div>
            </div>
            <div className="container mt-5">
                {/* Contact Heading */}
                <section id="about" className="text-center mb-5">
                    <h2 className="elementor-heading-title">Contact Us</h2>
                </section>

                {/* Contact Info + Image */}
                <section className="row align-items-center">
                    {/* Left: Contact Details */}
                    <div className="col-md-6">
                        <h2 id="text">Help & Support</h2>
                        <ul className="list-unstyled mt-4">
                            <li className="mb-3 text-dark">
                                <i className="bi bi-geo-alt-fill me-2"></i>
                                <strong>Location:</strong><br />
                                Delight consultancy #36, 1st main, 12th Cross Annsandrapalya, Hal.
                            </li>
                            <li className="mb-3 text-dark">
                                <i className="bi bi-telephone-fill me-2"></i>
                                <strong>Call Us:</strong><br />
                                8861182974<br />

                            </li>
                            <li className="mb-3 text-dark">
                                <i className="bi bi-envelope-fill me-2"></i>
                                <strong>Email Us:</strong><br />
                                <br />

                            </li>
                        </ul>

                        {/* Social Icons */}
                        <div className="social-icons-section2">
                            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon bg-primary">
                                <i className="bi bi-facebook"></i>
                            </a>
                            <a href="https://wa.me/8861182974" target="_blank" rel="noopener noreferrer" className="social-icon bg-success">
                                <i className="bi bi-whatsapp"></i>
                            </a>
                            <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-icon bg-dark">
                                <i className="bi bi-github"></i>
                            </a>
                            <a href="https://google.com" target="_blank" rel="noopener noreferrer" className="social-icon bg-danger">
                                <i className="bi bi-google"></i>
                            </a>
                            <a href="skype:live:yourusername?call" className="social-icon bg-info">
                                <i className="bi bi-skype"></i>
                            </a>
                        </div>
                    </div>

                    {/* Right: Image */}
                    <div className="col-md-6 text-center">
                        <img
                            src="https://img.freepik.com/free-vector/female-customer-service-worker-sitting-laptop-call-center-operator-headphones-flat-vector-illustration-customer-support-communication-concept-banner-website-design-landing-web-page_74855-21837.jpg?semt=ais_hybrid&w=740"
                            alt="Contact Visual"
                            className="img-fluid"
                            width="600"
                            height="400"
                            id="first-img"
                        />
                    </div>
                </section>

                {/* Map */}
                <section className="mt-5">
                    <h3 id="map">Our Location</h3>
                    <div className="w-100 mt-3 rounded overflow-hidden">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4623.800029815399!2d77.66572338192954!3d12.96309243197152!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae13e4226b559b%3A0xddf12efe5d9d7a33!2s36%2C%201st%20Main%20Rd%2C%20Annasandrapalya%20Extension%2C%20Islampur%2C%20Bengaluru%2C%20Karnataka%20560017!5e0!3m2!1sen!2sin!4v1753094578587!5m2!1sen!2sin"
                            width="1400"
                            height="450"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Google Map Location"
                        />

                    </div>
                </section>
            </div>

        </div>
    );
};

export default Contact;
